package fr.frux.feature.treedetail.move

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [MoveTreeViewModel], honoré par le composition root (#43). */
fun interface MoveTreeViewModelFactory {
    fun create(args: MoveTreeArgs): MoveTreeViewModel
}

/** Fabrique installée par le composition root, sans défaut pour que l'oubli de câblage crie. */
val LocalMoveTreeViewModelFactory =
    staticCompositionLocalOf<MoveTreeViewModelFactory> {
        error("MoveTreeViewModelFactory absente : le composition root doit l'installer (#43)")
    }

/** Fabrique le ViewModel du déplacement, porté par l'entrée de navigation. */
@Composable
fun rememberMoveTreeViewModel(args: MoveTreeArgs): MoveTreeViewModel {
    val factory = LocalMoveTreeViewModelFactory.current
    return viewModel { factory.create(args) }
}
